import { IconCup } from '@tabler/icons-react';

export default function TarjetaPOS({ name, price, image, onAdd }) {
  return (
    <button
      type="button"
      onClick={onAdd}
      aria-label={`Agregar ${name}`}
      className="flex flex-col w-full h-full min-w-0 rounded-2xl overflow-hidden border-none p-0 text-left cursor-pointer touch-manipulation select-none transition-colors duration-200 ease-out active:scale-[0.98] bg-[#141414] [@media(hover:hover)]:hover:bg-[#181818]"
      style={{ fontFamily: '"Public Sans", sans-serif' }}
    >
      <div className="flex items-center justify-center flex-1 min-h-0 w-full p-3.5 pb-1">
        {image ? (
          <img
            src={image}
            alt={name}
            className="w-full h-full max-h-[132px] object-contain"
            draggable={false}
          />
        ) : (
          <div className="flex flex-col items-center justify-center gap-1">
            <IconCup size={44} color="rgba(255, 255, 255, 0.22)" stroke={1.1} />
            <span style={{ fontSize: '11px', fontWeight: 500, color: 'rgba(255, 255, 255, 0.3)' }}>
              Sin imagen
            </span>
          </div>
        )}
      </div>

      <div className="w-full px-3.5 pb-3.5 shrink-0">
        <span
          className="block font-semibold truncate"
          style={{
            fontSize: '15px',
            lineHeight: '20px',
            letterSpacing: '-0.01em',
            color: 'rgba(255, 255, 255, 0.92)',
          }}
          title={name}
        >
          {name}
        </span>
        <span
          className="block mt-0.5 font-semibold"
          style={{
            fontSize: '15px',
            lineHeight: '20px',
            color: 'rgba(255, 255, 255, 0.95)',
            fontVariantNumeric: 'tabular-nums',
            letterSpacing: '-0.01em',
          }}
        >
          ${price}
        </span>
      </div>
    </button>
  );
}
